import { render, staticRenderFns } from "./ReviewCategoryAdd.vue?vue&type=template&id=0c6e33ad"
import script from "./ReviewCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ReviewCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports